module.exports = __webpack_public_path__ + "img/location_arrow.d4d3eb14.svg";